import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const DateContext = createContext({});

export const useDateContext = () => useContext(DateContext);

export const DateContextProvider = ({ children }) => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    axios
      .get("/api/info/date")
      .then((res) => {
        setDate(new Date(res?.data?.date));
      })
      .catch((e) => {
        setDate(new Date());
      });
  }, []);

  return (
    <DateContext.Provider value={{ date }}>{children}</DateContext.Provider>
  );
};
